export const storageAdd = {
	warningProductAlreadyOnList: "¡Este producto ya fue agregado a la lista!",
	title: "Agregar producto en el inventario {{storageName}}",
	cancel: "Cancelar",
	finish: "Concluido",
	addProductForm: {
		form: {
			modalWarning: {
				title: "Producto con costo cero",
				errorMessage:
					"El costo unitario cero impactará en el seguimiento de su CMV y perjudicará la lectura de algunos informes financieros. ¿Desea continuar de todos modos?",
				button: "No, llenar el costo",
			},
			label: {
				product: "Producto",
				count: "Cantidad",
				cost: "Precio de costo",
			},
			validation: {
				missingField: "Campo obligatorio",
				invalidQuantity: "Cantidad inválida",
			},
			submit: "Agregar",
		},
	},
	table: {
		columns: {
			product: "Producto",
			count: "Cantidad",
			unitcost: "Costo unitario",
			totalcost: "Costo total",
			action: "acción",
		},
	},
};
